export const SEND_REST="SEND_REST"

export const DEL_REST="DEL_REST"